import Image from '@atoms/Image/Image';
import Text from '@atoms/Text/Text';
import { IListingFilterItem } from '@models/IListing';
import classNames from 'classnames';

const ListingFilterItem = ({
  filter,
  image,
  colourHexCode,
  selected,
  isMobileFilters,
}: IListingFilterItem) => {
  return (
    <div
      className={classNames(
        'tw-flex tw-flex-col tw-items-center tw-gap-xxs tw-bg-transparent tw-text-center tw-text-black',
        isMobileFilters ? ' ' : 'tw-w-[90px] tw-py-[5px]',
        image?.url ? 'tw-w-[120px]' : '',
        'group',
      )}
    >
      <div
        className={classNames(
          'tw-relative tw-overflow-hidden tw-rounded-full tw-transition-colors',
          {
            'tw-h-3xl tw-w-3xl tw-bg-cover tw-object-cover tw-object-center md:tw-h-[90px] md:tw-w-[90px]':
              image?.url,
          },
          selected && isMobileFilters
            ? `tw-border tw-border-black after:tw-absolute after:tw-inset-[0] after:tw-box-content after:tw-block after:tw-rounded-full after:tw-border-[3px] after:tw-border-white after:tw-content-['']`
            : '',
          isMobileFilters ? 'tw-h-lg tw-w-lg' : 'tw-h-2xl tw-w-2xl',
        )}
        style={{
          backgroundColor: colourHexCode ? `#${colourHexCode}` : '#fff',
        }}
      >
        {image?.url && (
          <Image
            aspectRatio={1}
            sizes="100"
            image={image}
            imageClasses="tw-h-full tw-w-full tw-object-cover tw-transition-transform tw-duration-300 tw-ease-out group-hover:tw-scale-125 group-focus:tw-scale-125"
          />
        )}
      </div>

      {!isMobileFilters && (
        <div className="tw-relative">
          <Text
            variant="label-12"
            className={classNames(
              'tw-transition-all tw-duration-300 group-hover:tw-text-black group-focus:tw-text-black',
              selected ? 'tw-font-semibold tw-text-black' : 'tw-text-grey-70',
            )}
          >
            {filter.label}
          </Text>
          <div
            className={classNames(
              selected ? 'tw-w-full tw-bg-black' : 'tw-w-0 tw-bg-grey-20',
              'tw-absolute tw-bottom-[-5px] tw-z-10 tw-h-[2px] tw-transition-all tw-duration-300 tw-ease-in-out-quart group-hover:tw-w-full group-focus:tw-w-full',
            )}
          />
        </div>
      )}
    </div>
  );
};

export default ListingFilterItem;
